import React, { Component } from "react";
import { H2 } from "@blueprintjs/core";
import "../css/SuperAdminDashboard.scss";
import "../css/DashboardWrapper.scss";
import SubmenuPills from './SubmenuPills'

class DashboardWrapper extends Component {
    render() {
        const { title, headerActions, filters, children } = this.props;

        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-content">
                    {children}
                </div>
            </div>
        );
    }
}

export default DashboardWrapper;
